module.exports = __webpack_public_path__ + "static/img/preview-07.fe84f12e.webp";